import { render, staticRenderFns } from "./headerEgazar.vue?vue&type=template&id=6f5371ec"
import script from "./headerEgazar.vue?vue&type=script&lang=js"
export * from "./headerEgazar.vue?vue&type=script&lang=js"
import style0 from "./headerEgazar.vue?vue&type=style&index=0&id=6f5371ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports